<template>
  <div class="wtxh-pagination" v-if="totalPage > 1">
    <span class="page-arrow" :class="{disabled: currentPage <= 1}" @click="goPrePage"><i class="el-icon-arrow-left"></i></span>
    <span
      v-for="p in showPageBtn"
      :key="'p'+p.index"
      :class="['page-num', {active: p.value === currentPage, dots: !p.value}]"
      @click="goToPage(p.value)"
    >{{ p.value || '···' }}</span>
    <span class="page-arrow" :class="{disabled: currentPage >= totalPage}" @click="goNextPage"><i class="el-icon-arrow-right"></i></span>
    <span class="page-input-wrap">
      <input
        class="page-input"
        type="text"
        v-model="inputPage"
        placeholder="请输入页码"
        @keyup.enter="jumpToPage"
      />
    </span>
  </div>
</template>

<script>
export default {
  name: "paginationWtxh",
  props: {
    num: {
      type: Number,
      default: 0,
    },
    limit: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      offset: 0,
      inputPage: "",
    };
  },
  computed: {
    totalPage() {
      return Math.ceil(this.num / this.limit);
    },
    currentPage() {
      return Math.ceil(this.offset / this.limit) + 1;
    },
    showPageBtn() {
      const total = this.totalPage;
      const cur = this.currentPage;
      let pages = [];
      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push({ value: i, index: i });
      } else if (cur <= 3) {
        pages = [1, 2, 3, 0, total].map((v, i) => ({ value: v, index: i }));
      } else if (cur >= total - 2) {
        pages = [1, 0, total - 2, total - 1, total].map((v, i) => ({ value: v, index: i }));
      } else {
        pages = [1, 0, cur - 1, cur, cur + 1, 0, total].map((v, i) => ({ value: v, index: i }));
      }
      return pages;
    },
  },
  methods: {
    goToPage(page) {
      if (!page || page === this.currentPage) return;
      this.offset = (page - 1) * this.limit;
      this.scrollTopAndEmit(page);
    },
    goPrePage() {
      if (this.currentPage <= 1) return;
      this.offset -= this.limit;
      this.scrollTopAndEmit(this.currentPage);
    },
    goNextPage() {
      if (this.currentPage >= this.totalPage) return;
      this.offset += this.limit;
      this.scrollTopAndEmit(this.currentPage);
    },
    jumpToPage() {
      const p = parseInt(this.inputPage);
      if (p >= 1 && p <= this.totalPage && p !== this.currentPage) {
        this.offset = (p - 1) * this.limit;
        this.scrollTopAndEmit(p);
      }
      this.inputPage = "";
    },
    scrollTopAndEmit(page) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$emit("getNew", page);
    },
  },
};
</script>

<style scoped lang="scss">
.wtxh-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 51px;
  gap: 10px;
  user-select: none;
}
.page-arrow {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  color: #666;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  i {
    font-size: 14px;
  }
  &:hover:not(.disabled) {
    border-color: #376cec;
    color: #376cec;
  }
  &.disabled {
    color: #ccc;
    border-color: #e8e8e8;
    background: #fafafa;
    cursor: not-allowed;
  }
}
.page-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  height: 40px;
  padding: 0 4px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 16px;
  color: #666;
  background: #fff;
  cursor: pointer;
  transition: all 0.2s;
  &:hover:not(.active):not(.dots) {
    border-color: #376cec;
    color: #376cec;
  }
  &.active {
    background-color: #376cec;
    border-color: #376cec;
    color: #fff;
    font-weight: 500;
  }
  &.dots {
    border: none;
    background: transparent;
    cursor: default;
    min-width: 30px;
    color: #999;
    font-size: 18px;
    letter-spacing: 2px;
  }
}
.page-input-wrap {
  margin-left: 10px;
}
.page-input {
  width: 120px;
  height: 38px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  text-align: center;
  font-size: 14px;
  color: #333;
  background: #fff;
  outline: none;
  transition: border-color 0.2s;
  &::placeholder {
    color: #bfbfbf;
    font-size: 16px;
  }
  &:focus {
    border-color: #376cec;
  }
}
</style>
